<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    tagType: (tagType$ | async),
    availableTags: (availableTags$ | async) ?? []
  }"
>
</ng-container>

<ng-template #template let-tagType="tagType" let-availableTags="availableTags">
  @if (tagType) {
    <mat-form-field flex>
      <mat-label>{{ tagType.displayName }}</mat-label>
      <mat-select [formControl]="formControl" (selectionChange)="selectionChanged($event.value)">
        <mat-option [value]="null">{{ noneSelectedText }}</mat-option>
        @for (tag of availableTags; track tag.tagId) {
          <mat-option [value]="tag.tagId">{{ tag.displayName }} </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</ng-template>
